import { render, staticRenderFns } from "./Plots.vue?vue&type=template&id=c9d27bf8&scoped=true"
import script from "./Plots.vue?vue&type=script&lang=ts"
export * from "./Plots.vue?vue&type=script&lang=ts"
import style0 from "./Plots.vue?vue&type=style&index=0&id=c9d27bf8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d27bf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9d27bf8')) {
      api.createRecord('c9d27bf8', component.options)
    } else {
      api.reload('c9d27bf8', component.options)
    }
    module.hot.accept("./Plots.vue?vue&type=template&id=c9d27bf8&scoped=true", function () {
      api.rerender('c9d27bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/Plots.vue"
export default component.exports